import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialSecurityPage() {
    const navigate = useNavigate();
    const [secure, setSecure] = useState(false);
    const canvasRef = useRef(null);
    const rainRef = useRef(null);

    // MATRIX EFFECT
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const columns = Math.floor(canvas.width / 20);
        const drops = Array(columns).fill(0);

        const draw = () => {
            ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.fillStyle = secure ? '#3b82f6' : '#ef4444'; // Blue if secure, Red if attack
            ctx.font = '15px monospace';

            for (let i = 0; i < drops.length; i++) {
                const text = String.fromCharCode(Math.random() * 128);
                const x = i * 20;
                const y = drops[i] * 20;

                // If secure, drops stop at the shield (middle of screen approx)
                if (secure && y > canvas.height / 2) {
                    // Bounce or disappear
                    ctx.fillStyle = '#60a5fa';
                    ctx.fillText('🛡️', x, y);
                    drops[i] = 0;
                } else {
                    ctx.fillText(text, x, y);
                    if (y > canvas.height && Math.random() > 0.975) drops[i] = 0;
                    drops[i]++;
                }
            }
        };

        const interval = setInterval(draw, 33);
        rainRef.current = interval;

        return () => clearInterval(interval);
    }, [secure]);

    return (
        <div style={{ height: '100vh', width: '100vw', background: 'black', color: 'white', fontFamily: 'Inter, sans-serif', position: 'relative', overflow: 'hidden' }}>
            <canvas ref={canvasRef} style={{ position: 'absolute', inset: 0 }} />

            <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>

                <div style={{ textAlign: 'center', marginBottom: 50, pointerEvents: 'auto' }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: 900, color: secure ? '#3b82f6' : '#ef4444', textShadow: `0 0 20px ${secure ? '#3b82f6' : '#ef4444'}` }}>
                        {secure ? 'PROTECTION ACTIVÉE' : 'MENACE DÉTECTÉE'}
                    </h1>
                    <p style={{ fontSize: '1.5rem', marginTop: 10 }}>
                        {secure ? 'Le Bouclier InfoColab repousse 100% des attaques.' : 'Votre site est vulnérable aux injections SQL, XSS et DDoS.'}
                    </p>
                </div>

                {/* VISUAL SHIELD */}
                <div style={{
                    width: 600, height: 600, borderRadius: '50% 50% 0 0',
                    background: secure ? 'radial-gradient(circle at bottom, rgba(59, 130, 246, 0.4), transparent 70%)' : 'transparent',
                    borderTop: secure ? '4px solid #3b82f6' : 'none',
                    boxShadow: secure ? '0 -10px 50px rgba(59, 130, 246, 0.5)' : 'none',
                    position: 'absolute', bottom: 0,
                    transition: 'all 0.5s ease-out'
                }} />

                <div style={{ position: 'absolute', bottom: 100, pointerEvents: 'auto' }}>
                    {!secure ? (
                        <button
                            onClick={() => setSecure(true)}
                            className="pulse-red"
                            style={{
                                padding: '25px 60px', borderRadius: 50, border: 'none',
                                background: '#ef4444', color: 'white', fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer',
                                boxShadow: '0 0 30px #ef4444'
                            }}
                        >
                            ACTIVER LE BOUCLIER 🛡️
                        </button>
                    ) : (
                        <div className="animate-pop" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
                            <div style={{ fontSize: '5rem' }}>🛡️</div>
                            <button onClick={() => setSecure(false)} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '10px 30px', borderRadius: 50, cursor: 'pointer' }}>Désactiver (Risqué)</button>
                        </div>
                    )}
                </div>
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'absolute', top: 30, right: 30, zIndex: 20, background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.2)', padding: '10px 20px', borderRadius: 8, color: 'white', cursor: 'pointer' }}>Quitter</button>

            <style>{`
                .pulse-red { animation: pulseRed 1s infinite; }
                @keyframes pulseRed { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }
                .animate-pop { animation: pop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
                @keyframes pop { from { opacity: 0; transform: scale(0.5); } to { opacity: 1; transform: scale(1); } }
            `}</style>
        </div>
    );
}
